var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H4.11111H13",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71429 4.4V3.2C5.71429 2.88174 5.83469 2.57652 6.04902 2.35147C6.26335 2.12643 6.55404 2 6.85714 2H9.14286C9.44596 2 9.73665 2.12643 9.95098 2.35147C10.1653 2.57652 10.2857 2.88174 10.2857 3.2V4.4M12 4.4V12.8C12 13.1183 11.8796 13.4235 11.6653 13.6485C11.4509 13.8736 11.1602 14 10.8571 14H5.14286C4.83975 14 4.54906 13.8736 4.33474 13.6485C4.12041 13.4235 4 13.1183 4 12.8V4.4H12Z",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V11",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7V11",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBlack);
export default __webpack_public_path__ + "static/media/trash-black.b295fe3df8ccf9a80d5d3ce1599c5238.svg";
export { ForwardRef as ReactComponent };